import { TenantEntity } from "../../../entities";
export const TenantRegisterRequestSchema = TenantEntity.schema.pick({
    tenantSlug: true,
    name: true,
});
export const TenantInitRegisterRequestSchema = TenantEntity.schema.pick({
    id: true,
    tenantSlug: true,
    name: true,
    version: true,
});
export const TenantUpdatePhaseRequestSchema = TenantEntity.schema.pick({
    id: true,
    phase: true,
});
//# sourceMappingURL=tenant-request.js.map